module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921032649_T.aa9fd02e.jpg";